export default __webpack_public_path__ + "static/media/ic-send-coin.432e5fdf.svg";